import React from "react";
import { Row, Col } from "antd";
import Img from "../../image/shop/why.png";

const Why = () => {
  return (
       <section  className="extra-effort py-[80px] px-[1rem]">
      <div className="container m-auto">
        <Row
          gutter={[24, 24]}
          align="middle"
          justify="center"
          className="overflow-hidden"
        >
          {/* Left: Image */}

          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="banner-text">
                <h4 className="font-outfit text-sm  md:text-base text-[#555]">
               More Than a Purchase
               </h4> 
              <h2 className="text-[40px] lg:text-[60px] font-cinzel text-start">
                Why Shop With Light Weave Beacon Legacy
              </h2>
              <p className="pb-5 text-[18px] text-[#000] text-start font-outfit mt-4">
                Every item sold through the Lightweave Shop contributes directly to the foundation’s mission. Your purchase helps fund artist grants, sponsor challenges, support education programs, and keep this creative community thriving.
              </p>
              <ul className="list-disc pl-5">
  <li className="pb-5 text-[18px] text-[#000] font-outfit">
    Funds creative grants and micro-grants
  </li>
  <li className="pb-5 text-[18px] text-[#000] font-outfit">
    Supports emerging and underrepresented artists
  </li>
  <li className="pb-5 text-[18px] text-[#000] font-outfit">
    Helps maintain free public challenges
  </li>
  <li className="pb-5 text-[18px] text-[#000] font-outfit">
    Expands educational resources
  </li>
  <li className="pb-5 text-[18px] text-[#000] font-outfit">
    Strengthens a global creative community
  </li>
</ul>

             
            </div>
             {/* Right: Text */}
          </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="mission-images">
              <img
                src={Img}
                className="w-full h-full object-contain rounded-lg "
                alt="img"
              />
            </div>
          </Col>

         
        </Row>
      </div>
    </section>
  )
}

export default Why
